import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Popup } from 'semantic-ui-react';
import { filters } from '@adc/blueprint';
import FilterButton from '../filterButton';
import FilterPanel from '../filterPanel';
import FilterGroupLayout from '../filterGroupLayout';
import { fullScreenModifier } from './fullScreenModifier';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const MobileFilter = ({ defaultButtonLabel = 'Filter', definitions, dataCollection, buttonWidth, onChange, onReset, elmId = 'filter', }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [filterNotSelectedButtonLabel, setFilterNotSelectedButtonLabel] = useState(defaultButtonLabel);
    const [buttonLabel, setButtonLabel] = useState(filterNotSelectedButtonLabel);
    useEffect(() => {
        setIsFilterSelected(!filters.utils.areAllFiltersReset(dataCollection));
        setButtonLabel(filterNotSelectedButtonLabel);
    }, [dataCollection, filterNotSelectedButtonLabel]);
    useEffect(() => {
        setFilterNotSelectedButtonLabel(defaultButtonLabel);
    }, [defaultButtonLabel]);
    useEffect(() => {
        setButtonLabel(filters.utils.getLabelFromAll(dataCollection, definitions, defaultButtonLabel));
    }, [dataCollection, defaultButtonLabel, definitions]);
    return (_jsx(Popup, { content: _jsx(FilterPanel, { elmId: `${elmId}_panel`, onOpen: setIsOpen, onReset: onReset, children: definitions.map(definition => {
                const data = dataCollection[definition.name];
                return (_jsx(FilterGroupLayout, { groupDefinition: definition, groupData: data, onChange: (key, value) => {
                        onChange(definition.name, key, value);
                    } }, definition.name));
            }) }), on: 'click', open: isOpen, onClose: () => setIsOpen(false), onOpen: () => setIsOpen(true), className: cx('filter-popup'), trigger: _jsx(FilterButton, { isFilterSelected: isFilterSelected, onOpen: setIsOpen, isOpen: isOpen, onReset: () => onReset(), label: buttonLabel, width: buttonWidth, elmId: `${elmId}_button` }), position: 'bottom left', popperModifiers: [fullScreenModifier] }));
};
export default MobileFilter;
//# sourceMappingURL=index.js.map